import { Shape } from '@teko/ds-desktop';
import { useProductDetailState } from 'contexts';
import { usePolicies, useTenantConfig } from 'hooks';
import { t } from 'i18n';
import { ProductProviderInfo } from 'modules/product-detail/shared/ProductProviderInfo';
import { Information, PolicyAndService } from '../PolicyAndService';

export const NewPolicies = () => {
  const { product } = useProductDetailState();
  const { isMobile } = useTenantConfig();

  const { salePolicies, otherPolicies } = usePolicies(
    product?.sku || '',
    product?.seller?.id,
  );

  return (
    <>
      {salePolicies?.length || otherPolicies?.length ? (
        <Shape
          backgroundColor="white"
          borderRadius="m"
          className="BOXCARDBODY-RIGHT"
          marginTop={isMobile ? 's8' : 's12'}
        >
          <ProductProviderInfo />
          <Shape padding={isMobile ? 's16' : 's8'}>
            {!!salePolicies?.length && (
              <PolicyAndService
                title={t('Chính sách bán hàng')}
                information={salePolicies as Information[]}
                max={4}
                columns={isMobile ? 1 : 2}
              />
            )}
            {!!otherPolicies?.length && (
              <PolicyAndService
                title={t('Dịch vụ khác')}
                information={otherPolicies as Information[]}
                max={4}
                columns={isMobile ? 1 : 2}
                marginTop="s12"
              />
            )}
          </Shape>
        </Shape>
      ) : null}
    </>
  );
};
